import logger from 'debug';
import type { Debugger } from 'debug';

/**
 * 浏览器开启debug日志，通过设置localStorage.debug = 'shoteyes:*'来开启
 */
class Debug {

  private readonly shoteyes = logger('shoteyes');
  private readonly main = logger('main');

  /**
   * 组件日志
   */
  get component(): Debugger {
    return this.shoteyes.extend('component');
  }
  get complex(): Debugger {
    return this.component.extend('complex');
  }
  get filter(): Debugger {
    return this.complex.extend('filter');
  }
  get common(): Debugger {
    return this.component.extend('common');
  }
  get layout(): Debugger {
    return this.component.extend('layout');
  }

  /**
   * 功能日志
   */
  get features(): Debugger {
    return this.shoteyes.extend('features');
  }
  get admin(): Debugger {
    return this.features.extend('admin');
  }
  get analysis(): Debugger {
    return this.features.extend('analysis');
  }
  get app(): Debugger {
    return this.features.extend('app');
  }
  get form(): Debugger {
    return this.features.extend('form');
  }
  get inspection(): Debugger {
    return this.features.extend('inspection');
  }
  get setting(): Debugger {
    return this.features.extend('setting');
  }
  get support(): Debugger {
    return this.features.extend('support');
  }

  /**
   * 基础设施日志
   */
  get infra(): Debugger {
    return this.main.extend('zf-infra');
  }
  get service(): Debugger {
    return this.shoteyes.extend('service');
  }
  get store(): Debugger {
    return this.shoteyes.extend('store');
  }
  get storybook(): Debugger {
    return this.shoteyes.extend('storybook');
  }

}

export const debug = new Debug();
